module.exports = __webpack_public_path__ + "static/media/medianet.d9aa55d7.png";